export default __webpack_public_path__ + "static/media/universal-gif.55606c18.gif";